import { axiosAuthInstance } from "./axiosInstance";

type ISignInPayload = {
    email: string;
    password: string;
}

export const signIn = (payload: ISignInPayload) => {
    return axiosAuthInstance({
      method: "POST",
      // DVS-1599: credentials go in the JSON body. In the query string they were logged in plaintext.
      url: "loginmember",
      data: { username: payload.email, password: payload.password }
    });
  };